import {
  FilePreviewStyled,
  FileViewerControlsSectionStyled,
  FileViewerStyled,
} from '@procurify/ui'
import styled from 'styled-components'

export const EditExpenseLineItemDrawerDocumentStyled = styled.div`
  width: 100%;
  height: 100%;

  ${FileViewerStyled}, ${FilePreviewStyled} {
    background-color: transparent;
  }

  ${FileViewerControlsSectionStyled} {
    padding: 1rem;
  }
`
